export default __webpack_public_path__ + "static/media/suggestion-chips-dialog3.08c0b908.png";